import React from 'react'
import { useSelector } from 'react-redux'
import { lang } from 'utils/helpers'
import { getStaticImage } from 'utils/statics'

const MentionsReactions = ({ openPage }) => {
  const { mentions = 0 } =   useSelector(state => state.inchat)
  return (
    <div className='inchat-container inchat-mentions-container'>
      <div className='inchat-container__header' onClick={() => openPage('mentions')}>
        <img src={getStaticImage('/icons/orange-brand/icon-reactions.svg')} alt='mentionsReactions' />
        <span className='inchat-container__title'>{lang('dashboard_mentions-reactions')}</span>
        { mentions > 0 &&
          <div className='inchat-container__count'>
            <span>{mentions}</span>
          </div>
        }
      </div>
    </div>
  )
}

export default MentionsReactions